<template>
  <BaseDrawer v-if="!hidden" ref="drawer">
    <template #trigger>
      <button
        class="flex cursor-pointer items-stretch justify-between overflow-hidden rounded-lg text-gray-400 hover:bg-white"
      >
        <div class="p-1">
          <BaseIcon name="question" class="mb-0.5 text-lg" />
          Leer meer over het gebruik van deze tabel.
        </div>
        <div
          class="flex items-center justify-center px-1 hover:bg-gray-100"
          @click="hidden = true"
        >
          <BaseIcon name="close" class="mt-0.5 text-lg" />
        </div>
      </button>
    </template>
    <template #content>
      <TextDrawerTitle class="border-b border-gray-100 p-4 md:p-6">
        <BaseIcon name="question" filled class="mb-1" />
        Resultatentabel
      </TextDrawerTitle>
      <div class="flex flex-col gap-4 p-4 text-base font-normal md:p-6">
        <p>
          De resultatentabel bevat enkele functies om meer inzicht te krijgen in
          de resultaten. Hieronder volgt een kort overzicht.
        </p>
        <TextSubtitle class="mt-2 -mb-2"> Kolommen uitvouwen </TextSubtitle>
        <p>
          Een kolom met een plus symbool links van de naam kan worden
          uitgevouwen door op de naam te klikken. Hierdoor worden voorheen
          verborgen kolommen getoond die inzicht geven in de samenstelling van
          de originele kolom.
        </p>
        <img
          src="/src/assets/explainer-expand-1.png"
          alt="Klik op een kolom met een plus symbool om deze uit te vouwen"
          class="w-full rounded-lg border border-gray-200 shadow"
        />
        <img
          src="/src/assets/explainer-expand-2.png"
          alt="De verborgen kolommen worden getoond"
          class="w-full rounded-lg border border-gray-200 shadow"
        />
        <TextSubtitle class="mt-2 -mb-2">
          Inzoomen op een periode
        </TextSubtitle>
        <p>
          Door op een rij te klikken wordt er ingezoomd op de periode van die
          rij. Dit kan een specifieke dag, maand of jaar zijn.
        </p>
        <img
          src="/src/assets/explainer-zoom-1.png"
          alt="Klik op een rij om in te zoomen op die periode"
          class="w-full rounded-lg border border-gray-200 shadow"
        />
        <p>
          Klikken op de <span class="italic">Totaal</span> rij doet het
          tegenovergestelde door juist uit te zoomen.
        </p>
        <img
          src="/src/assets/explainer-zoom-2.png"
          alt="Klik op de Totaal rij om terug te zoomen naar de gehele periode"
          class="w-full rounded-lg border border-gray-200 shadow"
        />
        <TextSubtitle class="mt-2 -mb-2"> Uitleg over kolommen </TextSubtitle>
        <p>
          Sommige kolomnamen hebben een
          <BaseIcon
            name="information"
            filled
            class="mb-0.5 inline-block text-gray-300"
          />
          symbool rechts van de naam. Als de muis op dit symbool staat
          verschijnt er een tooltip met een korte beschrijving van de kolom.
          Erop klikken opent een uitgebreidere uitleg zoals deze over de
          betekenis van de kolom.
        </p>
        <img
          src="/src/assets/explainer-tooltip.png"
          alt="Klik op een kolom met een informatie symbool om de uitleg te openen"
          class="w-full rounded-lg border border-gray-200 shadow"
        />
      </div>
    </template>
  </BaseDrawer>
</template>

<script setup>
import { ref } from "vue"
import {
  TextSubtitle,
  TextDrawerTitle,
  BaseIcon,
  BaseDrawer,
} from "@repowerednl/ui-component-library"

const hidden = ref(false)
</script>
